import React from 'react';
import {NavLink} from 'react-router-dom';
import styled from 'styled-components';

import {CardBody} from './CardSections';
import {CardWrapper} from './CardWrapper';

/**
 * The `<CardNav>` component allows you to use a card as a navigation link.
 *
 * @param {object} param0
 * Props.
 *
 * @param {string | {pathname: string; search: string}} param0.to
 * The path to navigate to when the card is clicked.
 *
 * @param {'sm'} param0.size
 * Specify the size of the component.
 */
export const CardNav = ({to, size, children}) => {
    return (
        <NavigationCard to={to}>
            <CardWrapper size={size}>
                <CardBody>{children}</CardBody>
            </CardWrapper>
        </NavigationCard>
    );
};

const NavigationCard = styled(NavLink)`
    text-decoration: none;

    &.active {
        ${CardWrapper} {
            background: var(--container-background-active-color-200);
        }
    }
    &:hover {
        ${CardWrapper} {
            background: var(--container-background-hover-color-400);
            color: var(--container-text-hover-100);
        }
    }
`;
